import React from 'react';
import FilterBar from 'components/@common/FilterBar';
import { useTranslation } from 'react-i18next';
import FilterBarSelectInput from 'components/@common/FilterBar/FilterBarSelectInput';
import FilterBarSearchInput from 'components/@common/FilterBar/FilterBarSearchInput';
import FilterBarButton from 'components/@common/FilterBar/FilterBarButton';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { ProductFilter } from '../types';
import CloseIcon from '@material-ui/icons/Close';
import { useForm } from 'hooks/useForm';
import { useHistory } from 'react-router-dom';
import { buildSearchQueryParams } from 'utilities/query-params-util';

const useStyles = makeStyles((theme: Theme) => {
  return {
    root: {
      textAlign: 'center'
    },
    formControl: {
      width: '30%',
      [theme.breakpoints.down('sm')]: {
        width: '80%'
      }
    },
    button: {
      backgroundColor: theme.palette.common.white
    },
    buttonContainer: {
      [theme.breakpoints.down('sm')]: {
        display: 'block'
      }
    }
  };
});

export interface SupportFilterBarProps {
  product?: string;
  search?: string;
}

//TODO: Move this to the backend
const productFilters: Array<ProductFilter> = [
  { name: 'Plus Live Insights' },
  { name: 'Keyboarding Without Tears' },
  { name: 'HWT Interactive Digital Teaching Tool' },
  { name: 'HWT Digital Student App' },
  { name: 'BWC Interactive Digital Teaching Tool' },
  { name: 'GSS Interactive Digital Teaching Tool' },
  { name: 'Pre-K Interactive Teaching Tool' },
  { name: 'GSS Student Learning Apps' },
  { name: 'Wet-Dry-Try' },
  { name: 'A–Z for Mat Man® and Me Interactive Teaching Tool' },
  { name: 'A–Z for Mat Man® and Me Student App' },
  { name: 'Phonics, Reading, and Me™ Teacher Digital Tool' },
  { name: 'Phonics, Reading, and Me™ Student Digital Learning' }
];

const SupportFilterBar: React.FC<SupportFilterBarProps> = ({ product = '', search = '' }) => {
  const classes = useStyles();
  const { t } = useTranslation('SupportFilterBar');
  const [{ form }, { setForm, onFormChange }] = useForm({ product, search });
  const history = useHistory();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    handleFilterBarChange(event.target.name, event.target.value);
  };
  const isEmpty = Boolean(
    ((form.search && form.search.trim().length === 0) || !form.search) && !form.product
  );

  const handleReset = (): void => {
    setForm({ product: '', search: '' });
    history.push(`${history.location.pathname}`);
  };

  const onSearch = (): void => {
    const search = {} as { product: string; search: string };
    if (form.product) search.product = form.product;
    if (form.search) search.search = form.search;
    history.push(`${history.location.pathname}${buildSearchQueryParams(search)}`);
  };
  const handleFilterBarChange = (name: string, value: string): void => {
    onFormChange(name, value);
  };

  return (
    <FilterBar className={classes.root}>
      <FilterBarSearchInput
        onChange={handleChange}
        placeholder={t('Search the Knowledgebase')}
        name="search"
        value={form.search || ''}
        formControlProps={{ className: classes.formControl, marginDense: true }}
        size="medium"
      />
      <FilterBarSelectInput
        placeholder={t('Select a Product')}
        name="product"
        value={form.product ?? ''}
        onChange={handleChange}
        formControlProps={{ className: classes.formControl, marginDense: true }}
        size="medium"
      >
        {productFilters.map(
          ({ name }): React.ReactElement => {
            return (
              <MenuItem key={name} dense value={name}>
                {name}
              </MenuItem>
            );
          }
        )}
      </FilterBarSelectInput>
      <FilterBarButton
        color="primary"
        marginDense
        disabled={isEmpty}
        onClick={onSearch}
        containerProps={{ className: classes.buttonContainer }}
        className={classes.button}
        size="medium"
      >
        {t('Search')}
      </FilterBarButton>
      {!isEmpty && (
        <FilterBarButton
          marginDense
          onClick={handleReset}
          disabled={isEmpty}
          containerProps={{ className: classes.buttonContainer }}
          startIcon={<CloseIcon />}
          className={classes.button}
          size="medium"
        >
          {t('Clear')}
        </FilterBarButton>
      )}
    </FilterBar>
  );
};
SupportFilterBar.displayName = 'SupportFilterBar';
export default SupportFilterBar;
